import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=d9ae16cc&scoped=true&"
var script = {}
import style0 from "./Usage.vue?vue&type=style&index=0&id=d9ae16cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ae16cc",
  null
  
)

export default component.exports